import { Injectable }    from '@angular/core';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import { AuthService } from '../login/auth.service';

@Injectable()
export class UploadService {

  private headers: Headers;
  private url = environment.apiUrl;

  constructor(private http: Http, private authService: AuthService) {
    this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
  }

  private canvasToBlob(canvas, type, quality) {
    let dataURL = canvas.toDataURL(type, quality).split(',')[1];
    let binStr = atob( dataURL ),
        len = binStr.length,
        arr = new Uint8Array(len);

    for (let i = 0; i < len; i++ ) {
      arr[i] = binStr.charCodeAt(i);
    }

    return new Blob( [arr], {type: type || 'image/png'} );
  }

  // service function that uploads the given Ad: data=ad, queue=picture queue, orientation in is type of canvas (vertical or horizontal)
  upload(data: any, queue: any[], orientation_in: string, targetQueues: any[][]): Promise<boolean> {

    var adFile_counter = 0;   //count how many files for ad have been uploaded
    let formData: FormData = new FormData();

    formData.append("data", JSON.stringify(data));

    // set canvas orientation -> default is horizontal 1920x1080; if set to vertical then is 1080x1920
    let canvas_width = 1920;
    let canvas_height = 1080;
    if (orientation_in === 'vertical') {
      canvas_width = 1080;
      canvas_height = 1920;
    }
    
    let promises = [];

    for (const item of queue) {
      adFile_counter += 1;

      if(/video/i.test(item._file.type)) {
        formData.append("files[]", item._file, item._file.name);  
      } else {
        promises.push(new Promise((resolve, reject) => {
          let img = new Image();
          img.onload = () => {
            let resizeCanvas = document.createElement('canvas');
            resizeCanvas.width = canvas_width;
            resizeCanvas.height = canvas_height;
            //resizeCanvas.height = Math.floor(img.height * (canvas_width/img.width));
            
            let resizeCtx = resizeCanvas.getContext('2d');
            //resizeCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas_width, Math.floor(img.height * (canvas_width/img.width)));
            resizeCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas_width, canvas_height);

            let cropCanvas = document.createElement('canvas');
            cropCanvas.width = canvas_width;
            //cropCanvas.height = 755;
            cropCanvas.height = canvas_height;

            let cropCtx = cropCanvas.getContext('2d');
            let top = (img.height * (item.bounds.width/img.width) - item.bounds.height)/2 - item.top; 
            //cropCtx.drawImage(resizeCanvas, 0, Math.floor(top * (1080/item.bounds.width)), 1080, 755, 0, 0, 1080, 755);
            cropCtx.drawImage(resizeCanvas, 0, Math.floor(top * (canvas_width/item.bounds.width)), canvas_width, canvas_height, 0, 0, canvas_width, canvas_height);
            let blob = this.canvasToBlob(cropCanvas, 'image/jpeg', 0.95);
            formData.append("files[]", blob, item._file.name);
            resolve(true);    
          };
          img.src = URL.createObjectURL(item._file);  
        }));
      }  
    }

    targetQueues.forEach((tQueue, index) => {
      for (const item of tQueue) {
        adFile_counter += 1;
  
        if(/video/i.test(item._file.type)) {
          formData.append(`target_files_${index}[]`, item._file, item._file.name);  
        } else {
          promises.push(new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => {
              let resizeCanvas = document.createElement('canvas');
              resizeCanvas.width = canvas_width;
              resizeCanvas.height = canvas_height;
              //resizeCanvas.height = Math.floor(img.height * (canvas_width/img.width));
              
              let resizeCtx = resizeCanvas.getContext('2d');
              //resizeCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas_width, Math.floor(img.height * (canvas_width/img.width)));
              resizeCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas_width, canvas_height);
  
              let cropCanvas = document.createElement('canvas');
              cropCanvas.width = canvas_width;
              //cropCanvas.height = 755;
              cropCanvas.height = canvas_height;
  
              let cropCtx = cropCanvas.getContext('2d');
              let top = (img.height * (item.bounds.width/img.width) - item.bounds.height)/2 - item.top; 
              //cropCtx.drawImage(resizeCanvas, 0, Math.floor(top * (1080/item.bounds.width)), 1080, 755, 0, 0, 1080, 755);
              cropCtx.drawImage(resizeCanvas, 0, Math.floor(top * (canvas_width/item.bounds.width)), canvas_width, canvas_height, 0, 0, canvas_width, canvas_height);
              let blob = this.canvasToBlob(cropCanvas, 'image/jpeg', 0.95);
              formData.append(`target_files_${index}[]`, blob, item._file.name);
              resolve(true);
            };
            img.src = URL.createObjectURL(item._file);  
          }));
        }  
      }
    })

    /*
    // warn the User if closing the tab before whole Ad (all files) has been uploaded
    window.addEventListener('beforeunload', function (e) {
      if(adFile_counter != (queue.length-1)) {
        // Cancel the event
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = '';
      }
    });
    */
  
    return Promise.all(promises).then(()=>{
      var headers = new Headers({'Authorization': 'Bearer '+this.authService.getAuth().token})

      return this.http
        .post(this.url+'/promotion', formData, {headers: headers})
        .toPromise()
        .then(res => res.json().result as boolean)
        .catch(this.handleError);
    }); 
  }

  regions(params: any = null): Promise<Array<Region>> {
    return this.http
      .get(this.url+'/regions', {headers: this.headers, params: params})
      .toPromise()
      .then(res => res.json().regions as Array<Region>)
      .catch(this.handleError);
  }

  devices(params: any = null): Promise<Array<Device>> {
    return this.http
      .get(this.url+'/regions', {headers: this.headers, params: params})
      .toPromise()
      .then(res => res.json().devices as Array<Device>)
      .catch(this.handleError);
  }

  geo(params: any = null): Promise<Array<Country>> {
    return this.http
      .get(this.url+'/geo', {headers: this.headers, params: params})
      .toPromise()
      .then(res => {
        var countries = res.json().countries;
        countries.forEach((country, index, countries) => {
          country.cities.forEach((city, index, cities) => {
            city.regions.forEach((region, index, regions) => {
              region.coords.forEach((point, index, coords) => {
                coords[index] = Object.assign(new LatLng, point);
              });
              regions[index] = Object.assign(new Region, region);
            });
            cities[index] = Object.assign(new City, city);
          });
          countries[index] = Object.assign(new Country, country);
        });
        return countries;
      })
      .catch(this.handleError);
  }

  geoForStats(params: any = null): Promise<Array<Country>> {
    return this.http
      .get(this.url+'/geo_for_stats', {headers: this.headers, params: params})
      .toPromise()
      .then(res => {
        var countries = res.json().countries;
        countries.forEach((country, index, countries) => {
          country.cities.forEach((city, index, cities) => {
            cities[index] = Object.assign(new City, city);
          });
          countries[index] = Object.assign(new Country, country);
        });
        return countries;
      })
      .catch(this.handleError);
  }

  ads(): Promise<Array<Ad>> {
   
    return this.http
      .get(this.url+'/promotions', {headers: this.headers})
      .toPromise()
      .then(res => res.json().ads as Array<Ad>)
      .catch(this.handleError);
  }

  check(name: string): Promise<boolean> {
   
    return this.http
      .post(this.url+'/promotion/check', {name: name}, {headers: this.headers})
      .toPromise()
      .then(res => res.json().result as boolean)
      .catch(this.handleError);
  }

  getTimeslots(dates: Array<string>, regions: Array<any>, devices: Array<any> ): Promise<any>{
    let params = new URLSearchParams();
    
    dates.forEach(date => {
      params.append('dates[]', date);
    });

    regions.forEach(region => {
      params.append('regions[]', region.id);
    });

    devices.forEach(device => {
      params.append('devices[]', device.id);
    });
    
    //?date_from=2017-11-01&date_to=2017-11-03&regions[]=1&regions[]=2
    let options = new RequestOptions({ headers: this.headers, params: params }); 
    return this.http
      .get(this.url+'/timeslots', options)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  taxes(): Promise<Array<Tax>> {
   
    return this.http
      .get(this.url+'/taxes', {headers: this.headers})
      .toPromise()
      .then(res => res.json().taxes as Array<Tax>)
      .catch(this.handleError);
  }

  getInvoiceStatus(): Promise<number> {
    return this.http
      .get(this.url+'/me', {headers: this.headers})
      .toPromise()
      .then(res => res.json().user.invoiceStatus as number)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}

export class Tax {
  public id: number;
  public country: string;
  public vat: number;
  public name: string;
}


export class LatLng {
  public lat: number
  public lng: number
}

export class Region {
  public id: number
  public name: string
  public coords: Array<LatLng>
}

export class Device {
  public id: number
  public name: string
  public price: number
  public lat: number
  public lng: number
  public selected: boolean = false
}


export class Ad {
  public id: number
  public name: string
  public start_date: string
  public end_date: string
}

export class Country {
  public id: number
  public name: string
  public cities: Array<City>
}

export class City {
  public id: number
  public name: string
  public regions: Array<Region> = []
  public devices: Array<Device> = []
  private lat0: number
  private lng0: number
  private lat1: number
  private lng1: number
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/upload/upload.service.ts